import type { FC, ReactNode } from 'react'

import { Button } from '@/components/generals/button'
import { siteConfig } from '@/constants/site'

const ratings = [
    {
        logo: '/images/ng/google-g.svg',
        logoAlt: 'Google',
        score: '5.0',
        count: '(25 reviews)'
    }
]

/**
 * The hero photo is the section's own background image, set in the
 * NG Painting Pro block of `kitchen.css`.
 */
export const HomeHero: FC = (): ReactNode => {
    return (
        <section className='hero-section section-padding home'>
            <div className='w-layout-blockcontainer hero-container home w-container'>
                <div className='hero-content-wrapper home'>
                    <div className='hero-top-content-wrapper'>
                        <div className='hero-title-wrapper align-center'>
                            <h1 className='hero-title style-02' data-hero-reveal>
                                Professional painting services in Massachusetts
                            </h1>

                            <p className='hero-subtitle home' data-hero-reveal>
                                Transform your home or business with our expert painting services.
                                25+ years of experience, licensed and insured, with free estimates
                                and a 2-year warranty.
                            </p>
                        </div>

                        <div className='hero-button-wrapper' data-hero-reveal>
                            <Button
                                href='/book-free-consultation'
                                label='Get Free Estimate'
                                variant='style-02'
                            />

                            <Button
                                href={siteConfig.phoneHref}
                                label={`Call Now ${siteConfig.phone}`}
                                variant='style-03'
                            />
                        </div>
                    </div>

                    <div className='hero-bottom' data-hero-reveal>
                        {ratings.map((rating) => (
                            <div key={rating.logoAlt} className='hero-rating-wrapper'>
                                <img
                                    src={rating.logo}
                                    width={28}
                                    height={28}
                                    loading='lazy'
                                    alt={rating.logoAlt}
                                />

                                <div className='hero-rating-block'>
                                    <img src='/images/ratings.svg' loading='lazy' alt='' />

                                    <p className='hero-rating-number'>
                                        {rating.score}
                                    </p>

                                    <p className='hero-rating-text'>
                                        {rating.count}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='background-video w-background-video w-background-video-atom' aria-hidden='true' />

            <div className='hero-video-overlay' />
        </section>
    )
}
